module.exports = __webpack_public_path__ + "img/pre_overdue_light.977cc982.svg";